import React from "react";
import { useTitle } from "./useTitle";

interface UseTitleWrapperProps {
  title: string;
  children: React.ReactNode;
}
/**
 * A wrapper component that sets the document title using the provided `title` prop
 * and renders its children.
 *
 * @param {UseTitleWrapperProps} props - The props for the component.
 * @param {string} props.title - The title to set for the document.
 * @param {React.ReactNode} props.children - The child elements to render inside the wrapper.
 *
 * @returns {JSX.Element} The rendered children with the document title set.
 */
export const UseTitleWrapper = ({ title, children }: UseTitleWrapperProps) => {
  useTitle(title); // Set the page title
  return <>{children}</>;
};
